import {Injectable} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IBannerService } from './banner.service.interface';

@Injectable ({
    providedIn: 'root'
})

export class bannerService implements IBannerService{
    public showCancelledEnrolmentConfirmedBanner = new BehaviorSubject<boolean>(false);
    currentBannerState = this.showCancelledEnrolmentConfirmedBanner.asObservable();
    constructor() {}

    changeBannerState(state: boolean){
        this.showCancelledEnrolmentConfirmedBanner.next(state);
    }
    
}
